import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home"
import HardwareProducts from "@/views/HardwareProducts"
import SoftwareProduct from "@/views/SoftwareProduct"
import ContactUs from "@/views/ContactUs"
import NewsAndInformation from "@/views/NewsAndInformation"
import privacyPolicy from "@/views/privacyPolicy"
import NewsDetail from "@/views/NewsDetail"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/HardwareProducts',
    name: 'HardwareProducts',
    component: HardwareProducts
  },
  {
    path: '/SoftwareProduct',
    name: 'SoftwareProduct',
    component: SoftwareProduct
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/NewsAndInformation',
    name: 'NewsAndInformation',
    component: NewsAndInformation,
    // children:[
    //   {
    //       name:"NewsDetail",
    //       path:'NewsDetail',
    //       component:NewsDetail,
    //   }       
    // ]
  },
  {
    path: '/NewsDetail',
    name: 'NewsDetail',
    component: NewsDetail,
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy
  },
]

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
